export const createLatestRequestController = () => {
    let requestVersion = 0
    let activeAbortController: AbortController | null = null

    return {
        start: () => {
            requestVersion += 1
            activeAbortController?.abort()

            const currentVersion = requestVersion
            const abortController = new AbortController()
            activeAbortController = abortController

            return {
                signal: abortController.signal,
                isCurrent: () => currentVersion === requestVersion,
                finish: () => {
                    if (currentVersion === requestVersion && activeAbortController === abortController) {
                        activeAbortController = null
                    }
                },
            }
        },
        invalidate: () => {
            requestVersion += 1
            activeAbortController?.abort()
            activeAbortController = null
        },
    }
}